import { h, Component } from "preact";
import cx from "classnames";
import { Subscription, Subject } from "rxjs";
import moment from "moment-timezone";

import { ModalProps, Modal } from "../../common/modal";
import { Form, FieldList, Field } from "../../../../../types/form.model";
import * as Validators from "../../../../../types/validator.model";
import {
  validateForm,
  cxValidateField,
} from "../../../../../types/validator.model";
import linkform, { updateFormFieldValue } from "../../../../utils/linkform";

import {
  PurchaseDocument,
  ReceivingReport,
} from "../../../../../types/purchase-document.model";
import { ItemPiece } from "../../../../../types/item.model";
import { ItemWithdrawal } from "../../../../../types/item-withdrawal.model";

interface ViewIWProps extends ModalProps {
  iw: ItemWithdrawal;
}

interface ViewIWState {
  form?: Form;
  focusedRR?: ReceivingReport;
}

export class ViewIWModal extends Modal<ViewIWProps, ViewIWState> {
  form$: Subject<Form>;
  subs: Subscription[] = [];

  constructor(props) {
    super(props);

    this.createForm(props);
  }

  createForm(props: ViewIWProps) {
    let fields: FieldList = {
      reason: new Field([Validators.required], null, props.iw.reason),
      requestedBy: new Field([Validators.required], null, props.iw.requestedBy),
      status: new Field([Validators.required], null, props.iw.status),
    };

    this.form$ = new Subject<Form>();
    this.setState({
      form: new Form(fields),
    });

    this.form$.subscribe((form) => {
      validateForm(form);

      let state = {};
      state["form"] = form;
      this.setState(state);
    });
  }

  doModalClose = () => {
    if (this.props.close) {
      this.props.close();
    }
  };

  getFormBlock(props: ViewIWProps, state: ViewIWState) {
    const form = this.state.form;

    return (
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div class="col-12 col-lg-4 mt-3">
              <label class="anglo-remittance__submit-form__label">
                Requested By
              </label>
              <input
                className={cx("form-control", {
                  invalid: cxValidateField(form.fields["requestedBy"]),
                })}
                disabled={true}
                type="text"
                value={form.fields["requestedBy"].value}
                onChange={linkform(this.form$, form, "requestedBy")}
                placeholder="Requested By"
              />
            </div>
            <div class="col-12 col-lg-4 mt-3">
              <label class="anglo-remittance__submit-form__label">Status</label>
              <input
                className={cx("form-control", {
                  invalid: cxValidateField(form.fields["status"]),
                })}
                type="text"
                disabled={true}
                value={form.fields["status"].value}
                onChange={linkform(this.form$, form, "status")}
                placeholder="Status"
              />
            </div>
            <div class="col-12 col-lg-4 mt-3">
              <label class="anglo-remittance__submit-form__label">Reason</label>
              <input
                className={cx("form-control", {
                  invalid: cxValidateField(form.fields["reason"]),
                })}
                type="text"
                disabled={true}
                value={form.fields["reason"].value}
                onChange={linkform(this.form$, form, "reason")}
                placeholder="Reason"
              />
            </div>
          </div>
          {this.getSignatures(props)}
          <div className="row mt-3">
            <div className="col-12">{this.getItemList(props.iw.itemCodes)}</div>
          </div>
        </div>
      </div>
    );
  }

  getSignatureBlock(
    title: string,
    fieldKey: string,
    dateFieldKey: string,
    iw: ItemWithdrawal
  ) {
    if (iw[fieldKey]) {
      return (
        <div className="col-3">
          <div className="card signature-block">
            <h4>{title}</h4>
            <div className="values">
              <p>{iw[fieldKey]}</p>
              <p>
                <i>{moment(iw[dateFieldKey]).format("MMMM DD, YYYY")}</i>
              </p>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

  getSignatures(props: ViewIWProps) {
    return (
      <div className="row mt-3">
        {this.getSignatureBlock(
          "Processed By",
          "processedBy",
          "dateProcessed",
          props.iw
        )}
        {this.getSignatureBlock(
          "Approved By",
          "approvedBy",
          "dateApproved",
          props.iw
        )}
      </div>
    );
  }

  getItemList(itemList: ItemPiece[]) {
    return (
      <div class="item-list data-grid">
        <div className="data-grid__row header">
          <div class="data-grid__col">Name</div>
          <div class="data-grid__col">Item Code</div>
          {/* <div class="data-grid__col">Supplier</div> */}
          <div class="data-grid__col">Amount</div>
          <div class="data-grid__col">Unit Price</div>
          <div class="data-grid__col">Remark</div>
        </div>
        {itemList.map((row, index) => {
          return (
            <div className="data-grid__row">
              <div class="data-grid__col">{row.name}</div>
              <div class="data-grid__col">{row.itemCode}</div>
              {/* <div class="data-grid__col">{row.supplierId}</div> */}
              <div class="data-grid__col">{row.amount}</div>
              <div class="data-grid__col">{row.unitPrice}</div>
              <div class="data-grid__col">{row.remark}</div>
            </div>
          );
        })}
      </div>
    );
  }

  render(props: ViewIWProps, state: ViewIWState) {
    return (
      <div
        class="container anglo-modal create-disposal-modal"
        ref={(node) => (this.refNode = node)}
      >
        <div class="row anglo-modal__head align-items-center">
          <div class="col-9 col-md-10">
            <h3 class="mb-0">Item Withdrawal | {props.iw.itemWithdrawalId}</h3>
          </div>
          <div class="col-3 col-md-2">
            <button
              class="btn btn-outline-light w-100"
              onClick={this.doModalClose}
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div class="row anglo-modal__body py-3">
          <div class="col-12 create-withdrawal-modal__body pb-3">
            {this.getFormBlock(props, state)}
          </div>
        </div>
      </div>
    );
  }
}
